import {Component, Input} from '@angular/core';
import {AnnotationHandler} from '../../annotation-handler';

@Component({
    selector: 'app-annotation-shape-menu',
    templateUrl: './annotation-shape-menu.component.html',
    styleUrls: ['./annotation-shape-menu.component.scss'],
    standalone: false
})
export class AnnotationShapeMenuComponent {
  @Input() curAnn: AnnotationHandler;
  @Input() isDialog: boolean;
}
